import React, { useState, useEffect ,useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import {ListDirectors, DirectorsDelete } from '../store/slices/directors.js';
import Loader from '../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../common/Table';
import AdminLayout from './AdminLayout';
import { toast } from 'react-hot-toast';

const DirectorsMaster = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef=useRef(null)

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [listDirectors, setListDirectors] = useState([]);
  const [columns, setcolumns] = useState([
    { header: 'Name', field: 'name' },
    { header: 'Type', field: 'type' },
    { header: 'Email', field: 'email' },
    { header: 'DIN', field: 'din' },
    { header: 'Phone', field: 'phone' },
    { header: 'Date of Appointment', field: 'date_of_appointment' },
    { 
      header: 'Actions', 
      field: 'actions', 
      isAction: true, 
      actionButtons: [
        { name: 'Edit', className: 'btn-default' }, 
        { name: 'Delete', className: 'btn-cancel' },
      ]
    }
  ]);
 

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
      navigate(`/director/edit/${item.id ? item.id : null}`)
  };


const fetchDirectors = async () => {

  setIsLoading(true);
  dispatch(ListDirectors({ profile_id: id }))
    .unwrap()
    .then((data) => {
      setIsLoading(false);
      setListDirectors(data?.data);
    })
    .catch(({ message }) => {
      setIsLoading(false);
      console.log(message);
      setListDirectors([]);
    });
}

  React.useEffect(() => {
    fetchDirectors()
  }, []);

    const handleDelete = (item) => {
      const confirmDelete = window.confirm('Are you sure you want to delete this Director?');
      if (confirmDelete) {
        setIsLoading(true);
        dispatch(DirectorsDelete({ id: item.id, profile_id: id }))
          .unwrap()
          .then(() => {
            setIsLoading(false);
            fetchDirectors(); // Refresh the invoice list
          })
          .catch(({ message }) => {
            // console.log(message)
            setIsLoading(false);
            toast.error(message);
          });
      }
    };


  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Filter data based on search query
  const filteredParties = listDirectors?.filter(party => 
    party?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.type?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.email?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.phone?.toLowerCase()?.includes(searchQuery?.toLowerCase())||
    party?.din?.toLowerCase()?.includes(searchQuery?.toLowerCase())||
    party?.date_of_appointment?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  return (
    <AdminLayout>
        {isLoading && <Loader />}
          <div className="row content-body">
            <div className="container-fluid">
              <div className="page-header">
                <div>
                  <h2 className="main-content-title tx-24 mg-b-5">Directors Master</h2>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Directors Master</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                    Directors List
                    </li>
                  </ol>
                </div>
                <div className="d-flex justify-content-end">
                  <button className="btn ripple btn-default" onClick={() => navigate('/director/create')}>
                    Add Director
                  </button>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12"> 
                 <Table
                    columns={columns}
                    data={filteredParties} 
                    tableRef={tableRef}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    currentPage={currentPage}
                    handleDelete={handleDelete}
                    totalCount={filteredParties.length} 
                    onPageChange={handlePageChange}
                    handleEdit={handleEdit}
                    handleSearchChange={handleSearchChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </AdminLayout>
  );
};

export default DirectorsMaster;
